import { render, staticRenderFns } from "./tariffServices.vue?vue&type=template&id=075c83f2&scoped=true&"
import script from "./tariffServices.vue?vue&type=script&lang=js&"
export * from "./tariffServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075c83f2",
  null
  
)

export default component.exports